import { createColumnHelper } from "@tanstack/react-table";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { ReactTable } from "components";
import { ReportTemplatesDashboardModal } from "modules/ReportTemplatesDashboard/components";
import "modules/ReportTemplatesDashboard/components/ReportTemplatesDashboardTable/ReportTemplatesDashboardTable.scss";
import { useReportTemplatesListQuery } from "modules/ReportTemplatesDashboard/hooks";

import type { ReportTemplate } from "models";

const columnHelper = createColumnHelper<ReportTemplate>();

export const ReportTemplatesDashboardTable = () => {
  const { t } = useTranslation();

  const [selectedReportTemplate, setSelectedReportTemplate] = useState<ReportTemplate | null>(null);

  const { data: reportTemplates, isFetching: isReportTemplatesFetching } = useReportTemplatesListQuery();

  const columns = [
    columnHelper.accessor("name", {
      header: t("v8_name", "Name"),
      cell: ({ row: { original } }) => original.name
    }),
    columnHelper.accessor("description", {
      header: t("v8_description", "Description"),
      cell: ({ row: { original } }) => original.description
    }),
    columnHelper.accessor(row => row, {
      id: "actions",
      header: "",
      size: 80,
      cell: ({ row: { original } }) => (
        <Button icon aria-label={t("v8_edit", "Edit")} className="edit-button" onClick={() => setSelectedReportTemplate(original)}>
          <Icon className="pen to square" />
        </Button>
      )
    })
  ];

  return (
    <div className="ReportTemplatesDashboardTable">
      <ReactTable isFetching={isReportTemplatesFetching} columns={columns} data={reportTemplates} />
      {selectedReportTemplate && <ReportTemplatesDashboardModal reportTemplate={selectedReportTemplate} onClose={() => setSelectedReportTemplate(null)} />}
    </div>
  );
};
